import { render, staticRenderFns } from "./FaqCategoryPicker.vue?vue&type=template&id=2a9eeee0&"
import script from "./FaqCategoryPicker.vue?vue&type=script&lang=js&"
export * from "./FaqCategoryPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports